import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import * as serviceWorker from './serviceWorker';
import store from './store/index';
import App from './web/App.js';
import './web/styles/index.scss';

window.store = store;

if (localStorage.getItem('api_url')) {
  window.$API_URL = localStorage.getItem('api_url');
} else {
  window.$API_URL = process.env.REACT_APP_API_ENDPOINT;
}

window.$GOOGLE_CLIENT_ID =
  '1073628338835-f88h1p72j4un59flcccu3q39jplabfv8.apps.googleusercontent.com';
window.$FACEBOOK_CLIENT_ID = '676315633323343';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorker.unregister();
